import PropTypes from 'prop-types';
import { Box } from 'roo-ui/components';
import FormattedCreditCard from 'components/Formatters/FormattedCreditCard';
import { RefundDisclaimer } from 'components/Disclaimers';

import { LineItem } from 'components/payments/primitives';
import * as propTypes from 'components/payments/propTypes';

const CreditCardLineItem = ({ total, paymentMethods }) => (
  <LineItem title="Credit card" totals={[total]}>
    {paymentMethods.map((creditCard, index) => (
      <Box key={index}>
        Refund will be made to{' '}
        <strong>
          <FormattedCreditCard cardType={creditCard.cardType} lastFourDigits={creditCard.lastFourDigits} />
        </strong>
        <RefundDisclaimer.Link />
      </Box>
    ))}
  </LineItem>
);

CreditCardLineItem.propTypes = {
  total: propTypes.total.isRequired,
  paymentMethods: PropTypes.arrayOf(propTypes.creditCardPaymentMethod).isRequired,
};

export default CreditCardLineItem;
